import React from 'react'
import smily from '../../../images/smile-icon.svg'
import { Button } from 'react-bootstrap'

const SatisfactoryWidget = 
(props) => {
    const handleDirectToAgent = ()=>{
     
      
        props.actionProvider.handleDirectToAgent()
    }
    
    const handleCloseUpChat = () => {
        props.closeChat()
    }
    const handleAnotherRequest = () => {
      props.actionProvider.handleAnotherRequest()
      
    }

    
  return (
    <div style={{backgroundColor: '#DFE1E1'}} className='py-3 px-2 text-align-center justify-content-center text-center align-items-center'>
      <img src={smily} alt='smily'/>
      <br/>
      <p>Are you satisfied with the response or you need more assistance?</p>
      
      <Button  className='mb-2'style={{backgroundColor:'#008080'}} onClick={handleDirectToAgent}>No, Direct me to an Agent </Button>
      <Button className='mb-2' onClick={handleAnotherRequest} style={{backgroundColor:'#008080'}} >I have another request</Button>
      <Button className='mb-2' style={{backgroundColor:'#008080'}} onClick={handleCloseUpChat} >Yes, Close Chat</Button>

    </div>
  )
}

export default SatisfactoryWidget
